export default __webpack_public_path__ + "static/media/6DegreesBgRemove.aeb8812c.png";